
import React from 'react';
import { Link } from 'react-router-dom';
import SubmitButton from './SubmitButton';
import { useLoginForm } from './LoginFormContext';
import { Button } from '@/components/ui/button';
import { supabase } from "@/integrations/supabase/client";

interface LoginFormActionsProps {
  isLoading?: boolean;
  isSaasInstance?: boolean;
  form?: any;
}

const LoginFormActions: React.FC<LoginFormActionsProps> = ({ 
  isLoading: externalIsLoading,
  isSaasInstance = false,
  form
}) => {
  let contextValues = { isLoading: false };
  
  try {
    contextValues = useLoginForm();
  } catch (error) {
    // Context not available, will use props instead
  }
  
  const { isLoading: contextIsLoading } = contextValues;
  const isLoading = externalIsLoading !== undefined ? externalIsLoading : contextIsLoading;
  
  // Added Google login method here instead of a separate file
  const handleGoogleLogin = async () => {
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: window.location.origin + '/dashboard', 
        }
      });
      
      if (error) {
        console.error('Google Login Error:', error);
      }
    } catch (error) {
      console.error('Google Login Failed:', error);
    }
  };

  return (
    <>
      <SubmitButton 
        isLoading={isLoading} 
        text="Log in" 
        loadingText="Logging in..."
        className="w-full h-11 bg-primary-blue hover:bg-primary-blue/90 text-white font-medium"
        variant="default"
      />

      <div className="text-center mt-4">
        <a href="/forgot-password" className="text-sm text-primary-blue hover:text-primary-blue/90 transition-colors">
          Forgot your password?
        </a>
      </div>
      
      {!isSaasInstance && (
        <div className="text-center mt-6">
          <p className="text-sm text-gray-600 mb-2">
            Don't have an account?
          </p>
          <Button
            variant="outline"
            size="sm"
            className="mx-auto hover:bg-primary-blue hover:text-white transition-colors"
            asChild
          >
            <Link to="/signup">
              Sign up
            </Link>
          </Button>
        </div>
      )}
      
      <div className="relative flex items-center justify-center mt-6">
        <div className="absolute border-t border-gray-300 w-full"></div>
        <div className="relative bg-white px-4 text-sm text-gray-500">or continue with</div>
      </div>
      
      <div className="mt-4">
        <Button 
          variant="outline" 
          type="button" 
          className="w-full h-11 flex items-center justify-center"
          onClick={handleGoogleLogin}
          disabled={isLoading}
        >
          <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
            <path
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              fill="#4285F4"
            />
            <path
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              fill="#34A853"
            />
            <path
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              fill="#FBBC05"
            />
            <path
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              fill="#EA4335"
            />
            <path d="M1 1h22v22H1z" fill="none" />
          </svg>
          Continue with Google
        </Button>
      </div>
    </>
  );
};

export default LoginFormActions;
